
<template>
     <div>
        <div class="flx-center">
            <div class="businessBackground" :style="{ background: 'url(' + $ossUrl + 'images/关于我们.jpg) no-repeat center', backgroundSize: '100%' }"></div>
        </div>
    <div class="footerBottom" style="">
      
      <div class="container" style="margin-top: 140px;">
      <div class="flx-justify-between">
       <div>
        <div class="aboutMain-Title">美通深圳总部</div>
        <div class="aboutMain-Content">
          <div >热线电话：   19928715441（微信同号）</div>
          <div>办公地址：   深圳市龙岗区坂田街道稼先路993号赣锋科技大厦1栋A座17-19-22层</div>
        </div>
       </div>
        <div>
          <img :src="$ossUrl+'icons/listen.png'">
        </div>
      </div>
       <div style="padding: 20px 0;">
        <img style="width: 100%;" :src="$ossUrl+'images/about/locations.jpg'" alt="">
       </div>
       <div style="margin-top: 60px;" class="aboutMain-Title">美通分公司</div>
       <el-row style="margin-top: 60px;" :gutter="0">
                <el-col v-for="(item,index) in companyList" :key="index" :span="12">
                    <div class="companyBox ">
                        <div class="companyTitle">{{item.title}}</div>
                          <div class="companyContent">
                                <div v-for="(itemData,indexData) in item.contentList" :key="indexData"> {{itemData.content}}</div>
                            </div>
                    </div>
                </el-col>
            
                
            </el-row>
      </div>
     
    </div>
     </div>
  </template>
  <script>
  
  
  /**
   * Index-1 component
   */
  export default {
      name:"about",
    components: {
    },
    data(){
      return {
        activeName: 'second',
        activeIndex: 1, // 默认选中第一个按钮
        buttons: [
          { label: '关于美通',transportMode:'OCEAN' },
          { label: '联系我们',transportMode:'AIR' },
          { label: '企业文化',transportMode:'RAIL' },
          { label: '企业招聘',transportMode:'ROAD' }
        ],
        companyList:[
        {
            title:'深圳总部',
            contentList:[
                {
                    content:'深圳市龙岗区坂田街道稼先路993号赣锋科技大厦1栋A座17-19-22层',
                }
            ]
        },
        // {
        //     title:'机场分部',
        //     contentList:[
        //         {
        //             content:'深圳市宝安区福永街道怀德国际大厦1501-04'
        //         }
        //     ]
        // },
        // {
        //     title:'观澜分部',
        //     contentList:[
        //         {
        //             content:'深圳市龙华区观澜街道牛湖社区观天路17号大地城红木市场'
        //         }
        //     ]
        // },
        {
            title:'广州分公司',
            contentList:[
                {
                    content:'广州市白云区鹤龙东路159号欧派创新设计大厦1104室'
                }
            ]
        },
        {
            title:'中山分公司',
            contentList:[
                {
                    content:'中山东区利和国际金融中心4701-03'
                }
            ]
        },
        {
            title:'佛山分公司',
            contentList:[
                {
                    content:'佛山市顺德区顺联智造汇18座首层118-125号铺'
                }
            ]
        },
        {
            title:'东莞分公司',
            contentList:[
                {
                    content:'东莞市南城街道寰宇汇金中心9栋A座3503室'
                }
            ]
        },
        {
            title:'上海分公司',
            contentList:[
                {
                    content:'上海市闵行区申长路1688号中骏广场1幢201室'
                }
            ]
        },
        {
            title:'义乌分公司',
            contentList:[
                {
                    content:'浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（美通供应链）'
                }
            ]
        },
        {
            title:'郑州分公司',
            contentList:[
                {
                    content:'郑州市航空港区洞庭湖路锦荣广场6号楼3楼311室'
                }
            ]
        },
        {
            title:'青岛分公司',
            contentList:[
                {
                    content:'青岛市市北区辽阳路567号浮山厚业中心5号楼1702户'
                }
            ]
        },
        {
            title:'合肥分公司',
            contentList:[
                {
                    content:'合肥市蜀山区经济开发区跨境电商监管区7号楼608-609室'
                }
            ]
        },
        {
            title:'宁波分公司',
            contentList:[
                {
                    content:'宁波市鄞州区首南街道天童南路700号荣安大厦B402'
                }
            ]
        },
        {
            title:'长沙分公司',
            contentList:[
                {
                    content:'长沙市岳麓区麓云路268号梅溪湖创新中心A区1802'
                }
            ]
        },
        {
            title:'厦门分公司',
            contentList:[
                {
                    content:'厦门市湖里区长虹路29号跨境电商产业园二号楼724-725室'
                }
            ]
        },
        {
            title:'成都分公司',
            contentList:[
                {
                    content:'成都市武侯区吉泰五路88号香年广场T3-2505'
                }
            ]
        },
        {
          title:'汕头分公司',
          contentList:[
            {
              content:'汕头市龙湖区龙华街道园林路龙头曲路片（7-9自编）'
            }
          ]
        },
        {
          title:'杭州分公司',
          contentList:[
            {
              content:'杭州市滨江区江南大道星城中心A座906'
            }
          ]
        },
        {
          title:'新疆阿拉山口',
          contentList:[
            {
              content:'新疆博州阿拉山口市博尔塔拉路118号友好生活广场3号楼104房'
            }
          ]
        },
        {
          title:'塔城分公司',
          contentList:[
            {
              content:'第九师163团1连南侧'
            }
          ]
        },
        {
          title:'苏州分公司',
          contentList:[
            {
              content:'江苏省苏州市吴中区金鸡湖街道凤凰国际大厦1107室'
            }
          ]
        },
        {
          title:'常州分公司',
          contentList:[
            {
              content:'江苏省常州市天宁区常州金融商务广场2号楼3楼T08'
            }
          ]
        },
        {
          title:'南京分公司',
          contentList:[
            {
              content:'南京市江宁区江云路66号瑞浩大厦822'
            }
          ]
        },
        {
          title:'温州分公司',
          contentList:[
            {
              content:'温州市龙湾区文昌创客小镇文昌路128号未来智慧城市产业园C栋8261室'
            }
          ]
        },
       ],
      }
    },
    methods: {
      handleClick(tab, event) {
          console.log(tab, event);
        },
      setActive(item,index) {
        if(index === 1){
          this.$router.push({
            name:'connection'
          })
        }else if(index === 2){
          this.$router.push({
            name:'corporateCulture'
          })
        }else if(index === 3){
          this.$router.push({
            name:'inviteJob'
          })
        }else {
          this.$router.push({
            name:'about'
          })
        }
        // this.activeIndex = index;
        
  
      },
    }
  };
  </script>
  <style src="../index.css" scoped></style>